module.exports = __webpack_public_path__ + "34cc5894dc213aee14614c703f93e853.svg";